import React, { useState } from "react";
import { observer } from "mobx-react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isValidPrePrintedBarcode } from "../../lib/SampleStore";
import classNames from "classnames";

function TestingPoint({ protocol, tp }) {
  var formattedTestDate;
  if (protocol.production_date) {
    var momentDate = moment(protocol.production_date, "DD/MM/YYYY");
    if (momentDate.isValid()) {
      formattedTestDate = momentDate.add(tp.p_day, "days").format("DD/MM/YYYY");
    }
  } else {
    console.log("not valid", protocol.production_date);
  }

  const validBarcode = isValidPrePrintedBarcode(tp.pre_printed_barcode);

  return (
    <tr className={validBarcode ? "valid" : ""}>
      <td>
        P+
        {tp.p_day}
      </td>
      <td>{formattedTestDate}</td>
      <td>{tp.client_suite_name}</td>
      <td>{tp.client_specification_name || "No specification"}</td>
      <td>{tp.actions_summary}</td>
      <td style={{ width: 150 }}>
        <input
          className="form-control input-sm"
          placeholder="Add Pre-printed Barcode"
          onChange={(e) => {
            tp.pre_printed_barcode = e.target.value;
          }}
          value={tp.pre_printed_barcode}
        />
      </td>
      <td style={{ width: 150 }}>
        <input
          className="form-control input-sm"
          placeholder="Add reference..."
          onChange={(e) => {
            tp.client_reference = e.target.value;
          }}
          value={tp.client_reference}
        />
      </td>
    </tr>
  );
}

TestingPoint = observer(TestingPoint);

export default function ProtocolRegistration({ sample, forceUpdate }) {
  const protocol = sample.protocol;

  const updateValueFromDate = (date) => {
    if (
      date &&
      moment(date).isValid() &&
      (moment(date) >= moment().add(2, "years") || moment(date) <= moment().add(-200, "days"))
    ) {
      protocol.production_date = "";
      forceUpdate();
      return;
    }

    protocol.production_date = date ? moment(date).format("DD/MM/YYYY") : null;
    forceUpdate();
  };

  return (
    <div className="sl-rg-protocol-registration">
      <div className="sl-rg-protocol-registration-details">
        Protocol Name: {protocol.name}
        <br />
        Enter Production Date:&nbsp;&nbsp;
        <DatePicker
          value={protocol.production_date}
          dateFormat="dd/MM/yyyy"
          onChange={updateValueFromDate}
          isClearable={true}
          onChangeRaw={(e) => {
            if (!e.target.value) clear();
          }}
          className="sl-rg-production-date-input"
        />
      </div>

      <table className="table table-very-condensed sl-rg-protocol-registration-table">
        <thead>
          <tr>
            <th style={{ maxWidth: 30 }}>P+</th>
            <th style={{ maxWidth: 120 }}>Test Date</th>
            <th>Testing Suite</th>
            <th>Specification</th>
            <th>Actions</th>
            <th>
              <b>Pre-printed Barcode</b>
            </th>
            <th>
              <b>Sample Reference *optional</b>
            </th>
          </tr>
        </thead>
        <tbody>
          {protocol.testing_points.map((tp) => (
            <TestingPoint sample={sample} protocol={protocol} tp={tp} />
          ))}
        </tbody>
      </table>
      <div className="sl-rg-warning">
        <i className="fa fa-exclamation-triangle" />
        &nbsp; Warning: If this protocol is modified during the sample registration process
        then you won't be able to register it. To fix this you will need to remove the protocol
        from your basket and re-add it.
      </div>
    </div>
  );
}
